import { useState, useEffect } from "react";

export default function Countdown({ dark = false }) {
  const target = new Date("2026-10-31T00:00:00").getTime();

  const calc = () => {
    const now = Date.now();
    const diff = Math.max(0, target - now);
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const [time, setTime] = useState(calc);

  useEffect(() => {
    const tick = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);
      setTime({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [target]);

  const blocks = [
    { value: time.days, label: "Days" },
    { value: time.hours, label: "Hours" },
    { value: time.minutes, label: "Min" },
    { value: time.seconds, label: "Sec" },
  ];

  const boxClass = dark
    ? "w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center border border-[#0A0A0A]/15 bg-[#0A0A0A]/5"
    : "w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center border border-white/20 bg-white/5 backdrop-blur-sm";
  const numClass = dark
    ? "text-xl sm:text-2xl text-[#0A0A0A] tracking-tight"
    : "text-xl sm:text-2xl text-white tracking-tight";
  const labelClass = dark
    ? "text-[9px] sm:text-[10px] tracking-[0.2em] uppercase text-[#888] mt-2"
    : "text-[9px] sm:text-[10px] tracking-[0.2em] uppercase text-white/40 mt-2";

  return (
    <div data-testid="countdown-timer" className="flex gap-2 sm:gap-3">
      {blocks.map((b) => (
        <div key={b.label} className="text-center">
          <div className={boxClass} style={{ fontStyle: "normal" }}>
            <span className={numClass}>
              {String(b.value).padStart(2, "0")}
            </span>
          </div>
          <p className={labelClass} style={{ fontStyle: "normal" }}>
            {b.label}
          </p>
        </div>
      ))}
    </div>
  );
}
